import { ChangeEvent, useMemo } from 'react';
import useTextInput, { ValidationLogic } from './useTextInput';
import i18n from '../../R/string/i18n';

const nicknameValidationLogics = (): ValidationLogic[] => [
  {
    logic: (nickname: string) => nickname.length <= 0,
    msg: i18n.nicknameEditFormNicknameIsRequired()
  }
];

function useNicknameInput(
  initVal: string
): [
  string,
  (e: ChangeEvent<HTMLInputElement>) => void,
  string | undefined,
  React.Dispatch<React.SetStateAction<string>>,
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
  () => void
] {
  const validationLogicsTranslated = nicknameValidationLogics();

  const [
    nickname,
    onChangeNickname,
    nicknameErr,
    setNickname,
    setNicknameNotTouched
  ] = useTextInput(initVal, validationLogicsTranslated, 1000);

  const hasError = useMemo(
    () => nicknameErr !== undefined && nicknameErr.length > 0,
    [nicknameErr]
  );

  const clearNicknameError = () => {
    setNicknameNotTouched(true);
  };

  return [
    nickname,
    onChangeNickname,
    nicknameErr,
    setNickname,
    hasError,
    setNicknameNotTouched,
    clearNicknameError
  ];
}

export default useNicknameInput;
